import { EventsTimeline, Text } from '@shared/components';
import { MovementStopDetails } from '@shared/types/movement';
import { StopPreview } from './StopPreview';

type StopPreviewsProps = {
  stops: MovementStopDetails[];
};

export function StopPreviews({ stops }: StopPreviewsProps) {
  return (
    <div className="flex flex-col gap-2">
      <Text type="body-sm" className="text-gray-500" isHeavy>
        Stops
      </Text>
      <EventsTimeline>
        {stops.map((stop, i) => {
          return <StopPreview key={i} stop={stop} index={i} />;
        })}
      </EventsTimeline>
    </div>
  );
}
